<template>
    <footer v-if="json" data-aos="custom-fade-in" >
        <div class="capper">
            <div class="capper-padded">
                <div class="flx-lrc">
                    <div class="flx-l">
                        <div class="icons">
                            <router-link to="/" aria-label="Home" >
                                <TtIcon class="tt" aria-label="Insomniac" />
                            </router-link>
                            <img class="playstation" alt="Playstation" :src="window.config.json.artifacts.playstation" />
                        </div>

                        <div class="address" v-html="addressWithLink"></div>
                    </div>
                    <div class="flx-cr">
                        <div class="flx-c">
                            <div class="linkkrow" >
                                <nav>
                                    <template v-for="(item, index) in json.footer.nav" :key="index" >
                                        <router-link v-if="item.target === '_self'" class="zlink-underline-leftright-dark" :aria-label="item.label" :to="item.link">{{ item.label }}</router-link>
                                        <a v-else class="zlink-underline-leftright-dark" :aria-label="item.label" :href="item.link" :target="item.target">{{ item.label }}</a>
                                    </template>
                                </nav>

                            </div>
                        </div>
                        <div class="flx-r">
                            <div class="items">
                                <Social/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="legal" v-html="legalLine"></div>
            </div>
        </div>
    </footer>
</template>
<script>
//state
//import Link from "@/components/pieces/Link";
import Social from '@/components/pieces/Social'
import TtIcon from "@/components/svgs/Tt.vue";
export default {
    name: "footerComponent",
    components: {
        TtIcon,
        Social
        //Link,
    },
    data() {
        return {
            window:window,
            document:document,
            json:null,
        }
    },
    computed: {
        addressWithLink() {
            let ret = this.json.footer.address
            if (this.json.footer.footerAddressLink?.url) {
                return `<a aria-label="Street Address"  href="${this.json.footer.footerAddressLink?.url}" target="_blank">${this.json.footer.address}</a>`
            } else {
                return ret
            }
        },
        legalLine() {
            if (!this.json.footer?.legal) {
                return ''
            } else {
                const currentYear = new Date().getFullYear();
                return this.json.footer.legal.replace('{year}', currentYear);
            }
        }
    },
    watch: {

    },
    mounted() {
        this.json = this.window.config.json.global
    },

    methods: {

    }
}
</script>